import React from 'react';

import {
  Breadcrumbs,
  BusinessContactForm,
  BusinessTariffsCard,
  InternetBanner,
  TextBlock,
} from '@/ui/index';

import { Questions } from '../../roaming';

import styles from './Bundles.module.scss';

const Bundles = ({ data }) => {
  return (
    <div>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} dark />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} dark medium />
      )}
      <div className={'wrapper'}>
        <TextBlock className={styles.text}>
          Choose All-in-One bundles in roaming for your trips to feel the
          superior benefit of boundless communication!
        </TextBlock>
      </div>
      {data?.offers && <BusinessTariffsCard data={data.offers} />}
      <div className={'wrapper'}>
        <TextBlock className={styles.text}>
          The monthly bundle is provided with 20% OFF (24 AZN) to Business
          subscribers within the campaign period. The information about
          expiration will be placed on the website.
        </TextBlock>
      </div>
      {data?.questions && (
        <Questions
          title={null}
          className={'wrapper'}
          questions={data.questions}
        />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </div>
  );
};

export default Bundles;
